import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=388f8b71&scoped=true&lang=pug&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=388f8b71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f8b71",
  null
  
)

export default component.exports